import { Button, ButtonProps } from 'platform-components/common';
import React from 'react';

import { NEW_YEAR_MODAL_CONTROL_VIEW } from './types';

type OmittedProps = 'view' | 'className';

interface Props extends Omit<ButtonProps, OmittedProps> {
    view: NEW_YEAR_MODAL_CONTROL_VIEW;
}

export const NewYearModalControl = ({ view, ...props }: Props) => {
    const getButtonView = () => {
        switch (view) {
            case NEW_YEAR_MODAL_CONTROL_VIEW.ACCEPT:
                return Button.VIEW.ACTION;
            case NEW_YEAR_MODAL_CONTROL_VIEW.DECLINE:
            default:
                return Button.VIEW.SECONDARY;
        }
    };

    const buttonView = getButtonView();

    return <Button className="new-year-modal__button" view={buttonView} {...props} />;
};
